export default __webpack_public_path__ + "static/media/icon-error-mobile.d4e40ab3.svg";